import React from 'react';

import IconButton from '../../../common2/IconButton';
import Tooltip from '../../../common/Tooltip';

import SidePanelOpenIcon from '../../../../icons/side-panel-open.svg';
import SidePanelCloseIcon from '../../../../icons/side-panel-close.svg';
import useInputId from '../../../common2/hooks/useInputId';

type Props = {
  isViewerOpen: boolean;
  onClick: () => void;
};

function DocumentsViewerButton(props: Props) {
  const { isViewerOpen, onClick } = props;
  const id = useInputId();

  const Icon = isViewerOpen ? SidePanelCloseIcon : SidePanelOpenIcon;
  const label = isViewerOpen ? 'Hide documents viewer' : 'Show documents viewer';

  return (
    <div data-tip data-for={id}>
      <IconButton ariaLabel={label} icon={Icon} onClick={onClick} />
      <Tooltip id={id} position="bottom" delayShow={1000}>
        {label}
      </Tooltip>
    </div>
  );
}

export default React.memo(DocumentsViewerButton);
